/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/modules/ed-free-gifts.js":
/*!*****************************************!*\
  !*** ./src/js/modules/ed-free-gifts.js ***!
  \*****************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var FreeGiftsMain = /*#__PURE__*/function (_HTMLElement) {
  _inherits(FreeGiftsMain, _HTMLElement);

  var _super = _createSuper(FreeGiftsMain);

  function FreeGiftsMain() {
    _classCallCheck(this, FreeGiftsMain);

    return _super.apply(this, arguments);
  }

  _createClass(FreeGiftsMain, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.freeGiftItems = this.querySelectorAll('.ed-free-gift-item');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      this.freeGiftItems.forEach(function (item) {
        item.querySelectorAll('[data-action="add-free-gift"]').forEach(function (btn) {
          btn.addEventListener('click', _this.onBtnClick.bind(_this));
        });
      });
    }
  }, {
    key: "onBtnClick",
    value: function onBtnClick(e) {
      // get the variant ID
      console.log('click');
      var component = e.target.closest('.ed-free-gift-item');
      var variantID = component.dataset.variantId;
      this.addToCart(variantID);
    }
  }, {
    key: "addToCart",
    value: function addToCart(variantId) {
      fetch("/cart/add.js", {
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: {
            '_free-gift': true
          }
        }),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function () {
        //location.reload()
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      })["catch"](function (e) {
        console.error(e);
      });
    }
  }]);

  return FreeGiftsMain;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-free-gifts-main', FreeGiftsMain);

var FreeGiftItem = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(FreeGiftItem, _HTMLElement2);

  var _super2 = _createSuper(FreeGiftItem);

  function FreeGiftItem() {
    _classCallCheck(this, FreeGiftItem);

    return _super2.apply(this, arguments);
  }

  _createClass(FreeGiftItem, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {//this.btnAddToCart = this.querySelector('[data-action="add-free-gift"]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {//this.btnAddToCart.addEventListener('click', this.addFreeGift.bind(this));
    }
  }, {
    key: "addFreeGift",
    value: function addFreeGift() {}
  }, {
    key: "addToCart",
    value: function addToCart(variantId) {
      fetch("/cart/add.js", {
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: {
            '_free-gift': true
          }
        }),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function () {//location.reload()
      })["catch"](function (e) {
        console.error(e);
      });
    }
  }]);

  return FreeGiftItem;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-free-gift-item', FreeGiftItem);

/***/ }),

/***/ "./src/js/modules/ed-product-configurator/category-selection.js":
/*!**********************************************************************!*\
  !*** ./src/js/modules/ed-product-configurator/category-selection.js ***!
  \**********************************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var CategorySelection = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CategorySelection, _HTMLElement);

  var _super = _createSuper(CategorySelection);

  function CategorySelection() {
    _classCallCheck(this, CategorySelection);

    return _super.apply(this, arguments);
  }

  _createClass(CategorySelection, [{
    key: "selectedCategory",
    get:
    /** GETTERS AND SETTERS **/
    function get() {
      return this.getAttribute('selected-category');
    },
    set: function set(value) {
      this.setAttribute('selected-category', value);
      this.dispatchEvent(new CustomEvent('ed:cfg:category:change', {
        bubbles: true,
        detail: {
          selectedCategory: value
        }
      }));
    }
  }, {
    key: "enableArrows",
    get: function get() {
      return this.getAttribute('enable-arrows');
    },
    set: function set(value) {
      this.setAttribute('enable-arrows', value);
    }
    /** END GETTERS AND SETTERS **/

  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this$currentCategory;

      this._attachSelectors();

      this._attachListeners();

      this.currentCategory = this.categoryItems[0]; // enable next category (01.12.22)

      (_this$currentCategory = this.currentCategory.nextElementSibling) === null || _this$currentCategory === void 0 ? void 0 : _this$currentCategory.classList.add('enabled'); // enable filter drawer when current category has filter

      if (this.currentCategory.getAttribute('filter-drawer-enabled' === 'true')) {
        this.dispatchEvent(new CustomEvent('ed:cfg:category:selected', {
          bubbles: true,
          detail: {
            blockId: this.currentCategory.dataset.blockId,
            filterDrawerEnabled: this.currentCategory.getAttribute('filter-drawer-enabled')
          }
        }));
      }
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.categoryItems = this.querySelectorAll('.category-item');
      this.arrowBack = this.querySelector('.arrow-left');
      this.arrowNext = this.querySelector('.arrow-right'); // for scroll

      this.categoryList = this.querySelector('.category-list');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      this.categoryItems.forEach(function (item) {
        item.addEventListener('click', _this.onClick.bind(_this, item));
      });
      this.arrowBack.addEventListener('click', this.onArrowBack.bind(this));
      this.arrowNext.addEventListener('click', this.onArrowNext.bind(this)); // handle overflow of category list

      this.handleOverflowingCategoryList(); // scroll handling

      this.handleArrows();
      this.categoryList.addEventListener('scroll', this.handleArrows.bind(this));
      document.addEventListener('ed-cfg:category:next', this.onCategoryNext.bind(this));
      document.addEventListener('ed-cfg:reset', this.onReset.bind(this));
      window.addEventListener('resize', this.handleOverflowingCategoryList.bind(this));
    }
  }, {
    key: "onClick",
    value: function onClick(category) {
      var _this$currentCategory2;

      // dont allow if not enabled
      if (!category.classList.contains('enabled')) {
        return;
      }

      this.categoryItems.forEach(function (item) {
        if (item !== category) {
          item.classList.remove('selected');
          item.setAttribute('selected', 'false');
        }
      });
      category.classList.add('selected');
      category.setAttribute('selected', 'true');
      this.selectedCategory = category.dataset.blockId;
      this.currentCategory = category; // handle filter button

      var filterDrawerEnabled = category.getAttribute('filter-drawer-enabled');
      this.dispatchEvent(new CustomEvent('ed:cfg:category:selected', {
        bubbles: true,
        detail: {
          blockId: category.dataset.blockId,
          filterDrawerEnabled: filterDrawerEnabled
        }
      })); // enable next category (01.12.22)

      (_this$currentCategory2 = this.currentCategory.nextElementSibling) === null || _this$currentCategory2 === void 0 ? void 0 : _this$currentCategory2.classList.add('enabled');
    }
  }, {
    key: "onCategoryNext",
    value: function onCategoryNext(e) {
      var nextCategory = this.currentCategory.nextElementSibling; // todo: is it allowed to go next?

      nextCategory.classList.add('enabled');
      this.onClick(nextCategory);
    }
  }, {
    key: "onArrowBack",
    value: function onArrowBack() {
      var prevCategory = this.currentCategory.previousElementSibling;

      if (!prevCategory || !prevCategory.classList.contains('enabled')) {
        return;
      }

      this.onClick(prevCategory);
    }
  }, {
    key: "onArrowNext",
    value: function onArrowNext() {
      var nextCategory = this.currentCategory.nextElementSibling;

      if (!nextCategory || !nextCategory.classList.contains('enabled')) {
        return;
      }

      this.onClick(nextCategory);
    }
  }, {
    key: "onReset",
    value: function onReset() {
      this.categoryItems.forEach(function (item, index) {
        if (index > 1) {
          // enables first two categories
          item.classList.remove('enabled');
        }
      });
      this.currentCategory = this.categoryItems[0];
    } // Scroll + Arrow handling

  }, {
    key: "handleArrows",
    value: function handleArrows() {
      var scrollContainer = this.categoryList;
      var scrollMax = scrollContainer.scrollWidth - scrollContainer.clientWidth; // arrow right

      if (scrollMax - scrollContainer.scrollLeft < 10) {
        this.arrowNext.classList.remove('visible');
      } else {
        this.arrowNext.classList.add('visible');
      } // arrow left


      if (scrollContainer.scrollLeft > 3) {
        this.arrowBack.classList.add('visible');
      } else {
        this.arrowBack.classList.remove('visible');
      }
    } // check overflow

  }, {
    key: "handleOverflowingCategoryList",
    value: function handleOverflowingCategoryList() {
      if (this.isOverflown(this.categoryList)) {
        this.categoryList.classList.add('overflow');
        this.enableArrows = 'true';
        this.handleArrows();
      } else {
        this.categoryList.classList.remove('overflow');
        this.enableArrows = 'false';
      }
    } // check overflow

  }, {
    key: "isOverflown",
    value: function isOverflown(element) {
      return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
    }
  }]);

  return CategorySelection;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-category-selection', CategorySelection);

var CategoryItem = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(CategoryItem, _HTMLElement2);

  var _super2 = _createSuper(CategoryItem);

  function CategoryItem() {
    _classCallCheck(this, CategoryItem);

    return _super2.apply(this, arguments);
  }

  _createClass(CategoryItem, [{
    key: "selected",
    get:
    /** GETTERS AND SETTERS **/
    function get() {
      return this.getAttribute('selected');
    },
    set: function set(value) {
      this.setAttribute('selected', value);
    }
    /** END GETTERS AND SETTERS **/

    /** OBSERVE ATTRIBUTES **/

  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, oldValue, newValue) {
      // handle pre select event, only one time
      if (attrName === 'selected' && newValue === 'true' && !this.preSelectApplied) {
        this.selectedCallback(newValue);
        this.preSelectApplied = true;
      }
    }
    /** OBSERVE ATTRIBUTES **/

  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();

      this.activeFilters = 0; // first already applies pre select, next ones dont.

      this.preSelectApplied = this.selected === 'true';
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {}
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('ed:cfg:filter-drawer:count', this.onFilterDrawerChange.bind(this));
    }
  }, {
    key: "selectedCallback",
    value: function selectedCallback() {
      this.dispatchEvent(new CustomEvent('ed:cfg:apply-preselect', {
        bubbles: true,
        detail: {
          blockId: this.dataset.blockId
        }
      }));
    }
  }, {
    key: "onFilterDrawerChange",
    value: function onFilterDrawerChange(e) {
      if (e.detail.blockId === this.dataset.blockId) {
        this.activeFilters = e.detail.count; // TODO: DO SOMETHING WITH IT LOL
      }
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['selected'];
    }
  }]);

  return CategoryItem;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-category-item', CategoryItem);

/***/ }),

/***/ "./src/js/modules/ed-product-configurator/filter-bar.js":
/*!**************************************************************!*\
  !*** ./src/js/modules/ed-product-configurator/filter-bar.js ***!
  \**************************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var FilterBar = /*#__PURE__*/function (_HTMLElement) {
  _inherits(FilterBar, _HTMLElement);

  var _super = _createSuper(FilterBar);

  function FilterBar() {
    _classCallCheck(this, FilterBar);

    return _super.apply(this, arguments);
  }

  _createClass(FilterBar, [{
    key: "visible",
    get:
    /** GETTERS AND SETTERS **/
    function get() {
      return this.getAttribute('visible');
    },
    set: function set(value) {
      this.setAttribute('visible', value);
    }
  }, {
    key: "blockId",
    get: function get() {
      return this.getAttribute('block-id');
    }
    /** END GETTERS AND SETTERS **/

  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.filterType = this.getAttribute('filter-type');
      this.activeFilters = [];

      this._attachSelectors();

      this._attachListeners();

      this.handleOverflowingFilterBar();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.filterItems = this.querySelectorAll('.color-filter-item, .filter-item'); //this.productsWrapper = this.querySelectorAll('.product-variants-wrapper');
      //this.productVariants = this.querySelectorAll('.product-variant-item');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      this.filterItems.forEach(function (item) {
        item.addEventListener('click', _this.onFilterSelect.bind(_this, item));
      });
      document.addEventListener('ed:cfg:category:selected', this.onCategoryChange.bind(this)); //document.addEventListener('ed:cfg:product:selected', this.onProductChange.bind(this));

      window.addEventListener('resize', this.handleOverflowingFilterBar.bind(this));
    }
  }, {
    key: "onFilterSelect",
    value: function onFilterSelect(item) {
      var removeFilter = false;
      var filter = {
        key: item.dataset.filterKey,
        value: item.dataset.filterValue
      };

      if (item.getAttribute('selected')) {
        removeFilter = true;
      }
      /*** MODE: SINGLE CHOICE ***/


      if (this.filterType === 'single-choice') {
        this.filterItems.forEach(function (filterItem) {
          filterItem.removeAttribute('selected');
        });
        /*** MODE: MULTIPLE CHOICE ***/
      } else if (this.filterType === 'multiple-choice') {
        if (removeFilter) {
          this.filterItems.forEach(function (filterItem) {
            if (item === filterItem) {
              // only remove if its selected
              filterItem.removeAttribute('selected');
            }
          });
        }
      }
      /** ON REMOVE **/


      if (removeFilter) {
        this.removeFilter(filter);
      } else {
        /** ON SELECT **/
        this.applyFilter(filter);
        item.setAttribute('selected', 'true');
      }

      document.dispatchEvent(new CustomEvent('ed:cfg:filter:change', {
        bubbles: true,
        detail: {
          blockId: this.blockId,
          filterType: this.filterType,
          filters: this.activeFilters
        }
      }));
    }
  }, {
    key: "applyFilter",
    value: function applyFilter(filter) {
      if (this.filterType === 'single-choice') {
        this.activeFilters = [];
      } else if (this.filterType === 'multiple-choice') {
        this.activeFilters = this.activeFilters.filter(function (x) {
          return x.key === filter.key && x.value !== filter.value;
        });
      }

      this.activeFilters.push(filter);
    }
  }, {
    key: "removeFilter",
    value: function removeFilter(filter) {
      this.activeFilters = this.activeFilters.filter(function (x) {
        return x.key === filter.key && x.value !== filter.value;
      });
    }
  }, {
    key: "onCategoryChange",
    value: function onCategoryChange(e) {
      this.visible = 'false';

      if (this.blockId === e.detail.blockId) {
        this.visible = 'true';
        this.checkAvailableMainFilters();
      }
    } // check, which filter is available to avoid empty product lists
    // OPT POTENTIAL: gets triggered on category select, but could be better only after compatibility check

  }, {
    key: "checkAvailableMainFilters",
    value: function checkAvailableMainFilters() {
      var currentProducts = document.querySelectorAll('ed-category-product-list[data-block-id="' + this.blockId + '"] .product-item:not(.incompatible)');
      this.filterItems.forEach(function (item) {
        var filter = {
          key: item.dataset.filterKey,
          value: item.dataset.filterValue
        };
        var isFilterAvailable = Array.from(currentProducts).some(function (product) {
          var productFilter = product.getAttribute('data-filter-' + filter.key);
          var productFilterValues = productFilter.split('|');
          return productFilterValues.includes(filter.value);
        });

        if (!isFilterAvailable) {
          item.classList.add('hidden');
        } else {
          item.classList.remove('hidden');
        }
      });
    }
    /** HANDLE OVERFLOW **/
    // check overflow

  }, {
    key: "handleOverflowingFilterBar",
    value: function handleOverflowingFilterBar() {
      if (this.isOverflown(this.firstElementChild)) {
        this.classList.remove('no-overflow');
      } else {
        this.classList.add('no-overflow');
      }
    } // check overflow

  }, {
    key: "isOverflown",
    value: function isOverflown(element) {
      return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
    }
  }]);

  return FilterBar;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-filter-bar', FilterBar);

/***/ }),

/***/ "./src/js/modules/ed-product-configurator/filters.js":
/*!***********************************************************!*\
  !*** ./src/js/modules/ed-product-configurator/filters.js ***!
  \***********************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ToggleFilterButton = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ToggleFilterButton, _HTMLElement);

  var _super = _createSuper(ToggleFilterButton);

  function ToggleFilterButton() {
    _classCallCheck(this, ToggleFilterButton);

    return _super.apply(this, arguments);
  }

  _createClass(ToggleFilterButton, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();

      this.categories = document.querySelectorAll('ed-category-item');
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.btnToggleFilter = this.querySelector('button');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.btnToggleFilter.addEventListener('click', this.onBtnToggleFilter.bind(this));
      document.addEventListener('ed:cfg:category:selected', this.onCategoryChange.bind(this));
    }
  }, {
    key: "onBtnToggleFilter",
    value: function onBtnToggleFilter() {
      var currentCategory = document.querySelector('ed-category-item.selected');
      var blockId = currentCategory.dataset.blockId;
      var filterDrawer = document.getElementById('facet-filter--' + blockId);
      filterDrawer.setAttribute('open', 'true');
    }
  }, {
    key: "onCategoryChange",
    value: function onCategoryChange(e) {
      if (e.detail.filterDrawerEnabled === 'true') {
        this.setAttribute('active', 'true');
      } else {
        this.removeAttribute('active');
      }
    }
  }]);

  return ToggleFilterButton;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-toggle-filter-button', ToggleFilterButton);

var FilterDrawerList = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(FilterDrawerList, _HTMLElement2);

  var _super2 = _createSuper(FilterDrawerList);

  function FilterDrawerList() {
    _classCallCheck(this, FilterDrawerList);

    return _super2.apply(this, arguments);
  }

  _createClass(FilterDrawerList, [{
    key: "blockId",
    get: function get() {
      return this.getAttribute('block-id');
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.btnFilterSubmit = this.closest('facet-filters').querySelector('.btn-filter-submit');
      this.filterCategories = this.querySelectorAll('collapsible-content[ed-filter]');
      this.filterItems = this.querySelectorAll('input.checkbox, input.color-swatch__radio');
      this.btnResetFilters = this.closest('facet-filters').querySelector('.ed-cfg-filter-drawer .btn-reset-filters');
      this.bubbleCount = this.closest('facet-filters').querySelector('.bubble-count');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      this.btnFilterSubmit.addEventListener('click', this.onFilterSubmit.bind(this));
      this.btnResetFilters.addEventListener('click', this.resetAllFilters.bind(this));
      this.filterItems.forEach(function (filterItem) {
        filterItem.addEventListener('change', _this.onFilterItemClick.bind(_this));
      });
      document.addEventListener('ed:cfg:reset-filters', this.resetAllFilters.bind(this));
      document.addEventListener('ed:cfg:filter:change', this.onMainFilterChange.bind(this));
    }
  }, {
    key: "onFilterItemClick",
    value: function onFilterItemClick() {
      this.onFilterSubmit();
    }
  }, {
    key: "onFilterSubmit",
    value: function onFilterSubmit() {
      var _this2 = this;

      var activeFilters = [];
      this.filterCategories.forEach(function (cat) {
        var filterTitle = cat.getAttribute('ed-filter-name');
        var activeValues = [];
        cat.querySelectorAll('input:checked').forEach(function (input) {
          activeValues.push(input.value);
        });
        activeFilters.push(_defineProperty({}, filterTitle, activeValues));
        _this2.activeFilters = activeFilters;
      });
      document.dispatchEvent(new CustomEvent('ed:cfg:filter-drawer:update', {
        detail: {
          blockId: this.blockId,
          filters: activeFilters
        }
      }));
      var activeFiltersCount = this.countActiveFilters();

      if (activeFiltersCount > 0) {
        this.btnResetFilters.classList.add('active');
        this.bubbleCount.classList.add('active');
        this.bubbleCount.innerText = activeFiltersCount;
      } else {
        this.btnResetFilters.classList.remove('active');
        this.bubbleCount.classList.remove('active');
      }

      document.dispatchEvent(new CustomEvent('ed:cfg:filter-drawer:count', {
        detail: {
          blockId: this.blockId,
          count: activeFiltersCount
        }
      }));
      this.checkAvailableFilters();
    }
  }, {
    key: "onBtnReset",
    value: function onBtnReset() {
      this.resetAllFilters();
    }
  }, {
    key: "resetAllFilters",
    value: function resetAllFilters() {
      this.filterItems.forEach(function (filterItem) {
        filterItem.checked = false;
      });
      this.onFilterSubmit();
    }
  }, {
    key: "countActiveFilters",
    value: function countActiveFilters() {
      var count = 0;
      this.filterItems.forEach(function (filterItem) {
        if (filterItem.checked === true) {
          count++;
        }
      });
      return count;
    }
  }, {
    key: "checkAvailableFilters",
    value: function checkAvailableFilters() {
      var currentProducts = document.querySelectorAll('ed-category-product-list[data-block-id="' + this.blockId + '"] .product-item:not(.incompatible, .hidden)');
      this.filterCategories.forEach(function (filterCategory) {
        // check if filter category is active, if yes, so no check is needed because of OR logic
        var checkedFilter = filterCategory.querySelector('input:checked');

        if (checkedFilter) {
          return;
        }

        var filterItems = filterCategory.querySelectorAll('input.checkbox, input.color-swatch__radio');
        filterItems.forEach(function (filterItem) {
          var filterTitle = filterItem.dataset.filterTitle;
          var isFilterAvailable = Array.from(currentProducts).some(function (product) {
            var productFilter = product.getAttribute('data-filter-' + filterTitle);
            var productFilterValues = productFilter.split('|');
            return productFilterValues.includes(filterItem.value);
          });

          if (!isFilterAvailable) {
            filterItem.disabled = true;
            filterItem.parentElement.classList.add('disabled');
          } else {
            filterItem.disabled = false;
            filterItem.parentElement.classList.remove('disabled');
          }
        });
      });
    }
  }, {
    key: "onMainFilterChange",
    value: function onMainFilterChange() {
      setTimeout(function () {
        this.checkAvailableFilters();
      }.bind(this), 100);
    }
  }]);

  return FilterDrawerList;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-filter-drawer-list', FilterDrawerList);

/***/ }),

/***/ "./src/js/modules/ed-product-configurator/order-summary.js":
/*!*****************************************************************!*\
  !*** ./src/js/modules/ed-product-configurator/order-summary.js ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _methods__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../methods */ "./src/js/modules/methods.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }



var OrderSummary = /*#__PURE__*/function (_HTMLElement) {
  _inherits(OrderSummary, _HTMLElement);

  var _super = _createSuper(OrderSummary);

  function OrderSummary() {
    _classCallCheck(this, OrderSummary);

    return _super.apply(this, arguments);
  }

  _createClass(OrderSummary, [{
    key: "active",
    get:
    /** GETTERS AND SETTERS **/
    function get() {
      return this.getAttribute('active');
    },
    set: function set(value) {
      this.setAttribute('active', value);
    }
    /** OBSERVE ATTRIBUTES **/

  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, oldValue, newValue) {
      if (attrName === 'active') {
        this.handleMobileButtons(newValue);
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.currentProducts = [];
      this.categories = document.querySelectorAll('ed-category-item');
      this.orderItems = this.querySelectorAll('.order-summary-item');

      this._attachSelectors();

      this._attachListeners(); // FOR TESTING:
      //this.active = true;

    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.btnAbort = this.querySelector('.btn-abort');
      this.btnSubmit = this.querySelector('.btn-submit');
      this.btnShare = this.querySelector('.btn-share');
      this.btnSave = this.querySelector('.btn-save');
      this.sharePopup = document.querySelector('ed-share-popup');
      this.finalPrice = document.getElementById('ed-cfg-final-price'); // mobile buttons on another component

      this.btnShareMobile = document.querySelector('.btn-share-container.mobile');
      this.btnSaveMobile = document.querySelector('.btn-save-container.mobile');
      this.btnFilterMobile = document.querySelector('.btn-filter-container.mobile');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.btnAbort.addEventListener('click', this.onBtnAbort.bind(this));
      this.btnSubmit.addEventListener('click', this.onBtnSubmit.bind(this));
      this.btnShare.addEventListener('click', this.onBtnShare.bind(this));
      this.btnShareMobile.addEventListener('click', this.onBtnShare.bind(this));
      this.btnSave.addEventListener('click', this.onBtnSave.bind(this));
      this.btnSaveMobile.addEventListener('click', this.onBtnSave.bind(this));
      document.addEventListener('ed:cfg:variant:selected', this.onVariantChange.bind(this));
      document.addEventListener('ed:cfg:remove-item', this.onVariantChange.bind(this));
    }
  }, {
    key: "onVariantChange",
    value: function onVariantChange(e) {
      if (e.detail.previewImg) {
        this.addProduct(e);
      } else {
        this.removeProduct(e);
      }

      this.updateOrderSummary();
    }
  }, {
    key: "handleMobileButtons",
    value: function handleMobileButtons(value) {
      if (value === 'true') {
        this.btnShareMobile.classList.add('visible');
        this.btnSaveMobile.classList.add('visible');
        this.btnFilterMobile.classList.remove('visible');
      } else {
        this.btnShareMobile.classList.remove('visible');
        this.btnSaveMobile.classList.remove('visible');
        this.btnFilterMobile.classList.add('visible');
      }
    }
    /** ORDER SUMMARY **/

  }, {
    key: "updateOrderSummary",
    value: function updateOrderSummary() {
      var _this = this;

      var finalPrice = 0;
      this.categories.forEach(function (category) {
        var categoryId = category.dataset.blockId;
        var orderItem = Array.from(_this.orderItems).find(function (x) {
          return x.dataset.blockId === categoryId;
        });

        var product = _this.currentProducts.find(function (x) {
          return x.detail.blockId === categoryId;
        });

        if (product) {
          orderItem.setAttribute('active', 'true');
          orderItem.setAttribute('selected-variant', product.detail.variantId); // set img

          var img = product.detail.thumbnailImg ? product.detail.thumbnailImg : product.detail.previewImg;
          document.getElementById('ed-cfg-img--' + categoryId).src = _this.createImg(img).src; // title

          document.getElementById('ed-cfg-title--' + categoryId).innerText = product.detail.title; // price

          var comparePrice = document.getElementById('ed-cfg-compare-price--' + categoryId);

          if (parseInt(product.detail.comparePrice) > parseInt(product.detail.price)) {
            comparePrice.style.display = 'block';
            comparePrice.innerText = (0,_methods__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(product.detail.comparePrice, '{{amount_with_comma_separator}} €');
          } else {
            comparePrice.style.display = 'none';
          }

          document.getElementById('ed-cfg-price--' + categoryId).innerText = (0,_methods__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(product.detail.price, '{{amount_with_comma_separator}} €');
          finalPrice += parseFloat(product.detail.price); // handle variant select

          var orderSummaryVariantSelect = document.getElementById('ed-cfg-vselect--' + categoryId);
          orderSummaryVariantSelect.innerHTML = '';

          if (product.detail.hasVariants) {
            var productSelect = document.getElementById('ed-cfg-' + product.detail.blockId + '--' + product.detail.productId);
            var element = document.createElement('ed-cfg-variant-item-selector');
            element.innerHTML = productSelect.innerHTML;
            orderSummaryVariantSelect.appendChild(element);
            orderSummaryVariantSelect.style.display = 'block';
          } else {
            orderSummaryVariantSelect.style.display = 'none';
          }
        } else {
          orderItem.removeAttribute('active');
          orderItem.removeAttribute('selected-variant');
        }
      }); // update final price

      this.updateFinalPrice(finalPrice);
    }
  }, {
    key: "updateFinalPrice",
    value: function updateFinalPrice(price) {
      this.finalPrice.innerText = (0,_methods__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(price, '{{amount_with_comma_separator}} €');
    }
  }, {
    key: "createImg",
    value: function createImg(src) {
      var img = new Image(); //img.onload = this.onImgLoad.bind(this);

      img.src = src;
      return img;
    }
    /** BUTTON METHODS **/

  }, {
    key: "onBtnAbort",
    value: function onBtnAbort() {
      this.active = 'false';
    }
  }, {
    key: "onBtnSubmit",
    value: function onBtnSubmit() {
      this.addToCart();
    }
  }, {
    key: "onBtnShare",
    value: function onBtnShare() {
      this.sharePopup.setAttribute('active', 'true');
    }
  }, {
    key: "onBtnSave",
    value: function onBtnSave() {
      var main = document.querySelector('ed-product-configurator-main');
      main.setAttribute('ed-loading', 'true');
      /*setTimeout(this.createSaveImage.bind(this), 500);*/
    }
    /*
        createSaveImage() {
            let main = document.querySelector('ed-product-configurator-main');
    
            html2canvas(document.querySelector('.ed-product-preview .preview-inner'), {
                useCORS: true,
                logging: true,
                removeContainer: true
            }).then(canvas => {
                // TODO Optimize
                let popup = document.querySelector('ed-save-popup');
                let canvasContainer = popup.querySelector('.ed-cfg-popup-inner .canvas-container');
                canvasContainer.innerHTML = '';
                canvasContainer.appendChild(canvas)
                popup.setAttribute('active', 'true');
    
                main.setAttribute('ed-loading', 'false');
            });
        }
    
     */

    /** GENERAL METHODS **/

  }, {
    key: "addProduct",
    value: function addProduct(e) {
      this.currentProducts = this.currentProducts.filter(function (x) {
        return x.detail.blockId !== e.detail.blockId;
      });
      this.currentProducts.push({
        detail: e.detail
      });
    }
  }, {
    key: "removeProduct",
    value: function removeProduct(e) {
      this.currentProducts = this.currentProducts.filter(function (x) {
        return x.detail.blockId !== e.detail.blockId;
      });
    }
  }, {
    key: "addToCart",
    value: function addToCart() {
      var _this2 = this;

      var isValid = true;
      this.btnSubmit.setAttribute('ed-loading', 'true');
      var items = [];
      this.currentProducts.forEach(function (product) {
        // HANDLE PRODUCTS WITH SELECT VARIANTS
        if (product.detail.hasVariants) {
          var variantSelect = _this2.querySelector('ed-cfg-variant-item-selector');

          var selectedVariantId = variantSelect.getAttribute('selected-variant-id');

          if (variantSelect && selectedVariantId) {
            var item = {
              id: selectedVariantId,
              quantity: 1,
              properties: {
                '_configuratorItem': true,
                '_bundle': '{{ product.title }}',
                '_bundleUrl': '{{ product.url }}'
              }
            };
            items.push(item);
          } else {
            isValid = false;
          } // DEFAULT

        } else if (product.detail.variantId) {
          var _item = {
            id: product.detail.variantId,
            quantity: 1,
            properties: {
              '_configuratorItem': true,
              '_bundle': '{{ product.title }}',
              '_bundleUrl': '{{ product.url }}'
            }
          };
          items.push(_item);
        }
      });
      var formData = {
        'items': items
      };

      if (!isValid) {
        alert('Bitte wähle noch deine Riemengröße aus.');
        this.btnSubmit.setAttribute('ed-loading', 'false');
        return;
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(function (response) {
        _this2.onAddToCart();

        _this2.btnSubmit.removeAttribute('ed-loading');

        return response.json();
      })["catch"](function (error) {
        _this2.btnSubmit.removeAttribute('ed-loading');

        console.error('Error:', error);
      });
    } // extrahiert, da theme abhängig

  }, {
    key: "onAddToCart",
    value: function onAddToCart() {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      document.getElementById('mini-cart').open = true;
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['active'];
    }
  }]);

  return OrderSummary;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-order-summary', OrderSummary);

var OrderSummaryItem = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(OrderSummaryItem, _HTMLElement2);

  var _super2 = _createSuper(OrderSummaryItem);

  function OrderSummaryItem() {
    _classCallCheck(this, OrderSummaryItem);

    return _super2.apply(this, arguments);
  }

  _createClass(OrderSummaryItem, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {}
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {}
  }]);

  return OrderSummaryItem;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-order-summary-item', OrderSummaryItem);

var OrderSummaryRemoveButton = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(OrderSummaryRemoveButton, _HTMLElement3);

  var _super3 = _createSuper(OrderSummaryRemoveButton);

  function OrderSummaryRemoveButton() {
    _classCallCheck(this, OrderSummaryRemoveButton);

    return _super3.apply(this, arguments);
  }

  _createClass(OrderSummaryRemoveButton, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.removePopUp = document.querySelector('ed-item-remove-popup');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.addEventListener('click', this.onBtnClick.bind(this));
      document.addEventListener('ed:cfg:remove-item:accept', this.onRemoveAccept.bind(this));
    }
  }, {
    key: "onBtnClick",
    value: function onBtnClick() {
      this.selectedCategory = this.parentElement.parentElement.parentElement.dataset.blockId;
      this.removePopUp.setAttribute('active', 'true');
    }
  }, {
    key: "onRemoveAccept",
    value: function onRemoveAccept() {
      if (this.selectedCategory) {
        document.dispatchEvent(new CustomEvent('ed:cfg:remove-item', {
          detail: {
            blockId: this.selectedCategory
          }
        }));
      }

      this.selectedCategory = null;
    }
  }]);

  return OrderSummaryRemoveButton;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-order-summary-item-remove', OrderSummaryRemoveButton);

/***/ }),

/***/ "./src/js/modules/ed-product-configurator/popups.js":
/*!**********************************************************!*\
  !*** ./src/js/modules/ed-product-configurator/popups.js ***!
  \**********************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ConfiguratorPopup = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ConfiguratorPopup, _HTMLElement);

  var _super = _createSuper(ConfiguratorPopup);

  function ConfiguratorPopup() {
    _classCallCheck(this, ConfiguratorPopup);

    return _super.apply(this, arguments);
  }

  _createClass(ConfiguratorPopup, [{
    key: "active",
    get:
    /** GETTERS AND SETTERS **/
    function get() {
      return this.getAttribute('active');
    },
    set: function set(value) {
      this.setAttribute('active', value);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.closeBtn = this.querySelector('.btn-close');
      this.closeBtn.addEventListener('click', this.onBtnClose.bind(this));
    }
  }, {
    key: "onBtnClose",
    value: function onBtnClose() {
      this.active = 'false';
    }
  }]);

  return ConfiguratorPopup;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

var SharePopup = /*#__PURE__*/function (_ConfiguratorPopup) {
  _inherits(SharePopup, _ConfiguratorPopup);

  var _super2 = _createSuper(SharePopup);

  function SharePopup() {
    _classCallCheck(this, SharePopup);

    return _super2.apply(this, arguments);
  }

  _createClass(SharePopup, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, oldValue, newValue) {
      if (attrName === 'active' && newValue === 'true') {
        this.generateShareUrl();
        this.generateWhatsappUrl();
      }
    }
    /** END **/

  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(SharePopup.prototype), "connectedCallback", this).call(this);

      this._attachSelectors();

      this._attachListeners(); // FOR TESTING:
      //this.active = true;

    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.copyBtn = this.querySelector('.copy-btn');
      this.copySuccessAlert = this.querySelector('.copy-success-alert');
      this.shareUrlInput = document.getElementById('ed-cfg-share-url');
      this.btnShareWhatsapp = this.querySelector('.btn-whatsapp-share');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.copyBtn.addEventListener('click', this.onCopyButton.bind(this));
    }
  }, {
    key: "generateShareUrl",
    value: function generateShareUrl() {
      var searchParams = new URLSearchParams(window.location.search);
      searchParams.set("share", 'true');
      var fullUrl = location.protocol + '//' + location.host;
      var newRelativePathQuery = fullUrl + window.location.pathname + '?' + searchParams.toString();
      this.currentShareUrl = newRelativePathQuery;
      this.shareUrlInput.value = newRelativePathQuery;
      return this.currentShareUrl = newRelativePathQuery;
    }
  }, {
    key: "generateWhatsappUrl",
    value: function generateWhatsappUrl() {
      var urlEncodedText = encodeURIComponent(this.getAttribute('share-text'));
      var urlEncodedLink = encodeURIComponent(this.currentShareUrl);
      this.btnShareWhatsapp.href = 'https://wa.me/?text=' + urlEncodedText + ' ' + urlEncodedLink;
    }
    /** COPY HANDLING **/

  }, {
    key: "onCopyButton",
    value: function onCopyButton() {
      // Get the text field
      var copyText = this.shareUrlInput; // Select the text field

      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices
      // Copy the text inside the text field

      navigator.clipboard.writeText(copyText.value); // handle message

      this.copySuccessAlert.classList.add('visible');
      setTimeout(this.hideCopyAlert.bind(this), 2000);
    }
  }, {
    key: "hideCopyAlert",
    value: function hideCopyAlert() {
      this.copySuccessAlert.classList.remove('visible');
    }
    /** END COPY HANDLING **/

  }], [{
    key: "observedAttributes",
    get:
    /** OBSERVE ATTRIBUTES **/
    function get() {
      return ['active'];
    }
  }]);

  return SharePopup;
}(ConfiguratorPopup);

customElements.define('ed-share-popup', SharePopup);

var IncompatibilityPopup = /*#__PURE__*/function (_ConfiguratorPopup2) {
  _inherits(IncompatibilityPopup, _ConfiguratorPopup2);

  var _super3 = _createSuper(IncompatibilityPopup);

  function IncompatibilityPopup() {
    _classCallCheck(this, IncompatibilityPopup);

    return _super3.apply(this, arguments);
  }

  _createClass(IncompatibilityPopup, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(IncompatibilityPopup.prototype), "connectedCallback", this).call(this);

      this._attachSelectors();

      this._attachListeners(); // FOR TESTING:
      //this.active = true;

    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.btnInitShare = this.querySelector('.btn-init-save');
      this.btnAccept = this.querySelector('.btn-accept');
      this.shareContainer = this.querySelector('.share-links-container');
      this.shareUrlInput = document.getElementById('ed-cfg-share-url-incompatibility');
      this.btnShareWhatsapp = this.querySelector('.btn-whatsapp-share');
      this.copyBtn = this.querySelector('.copy-btn');
      this.copySuccessAlert = this.querySelector('.copy-success-alert');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.btnAccept.addEventListener('click', this.onBtnAccept.bind(this));
      this.btnInitShare.addEventListener('click', this.onBtnInitSave.bind(this));
      this.copyBtn.addEventListener('click', this.onCopyButton.bind(this));
    }
  }, {
    key: "onBtnInitSave",
    value: function onBtnInitSave() {
      this.btnInitShare.style.display = 'none';
      this.shareContainer.classList.add('visible');
      this.generateShareUrl();
      this.generateWhatsappUrl();
    }
  }, {
    key: "onBtnAccept",
    value: function onBtnAccept() {
      // TODO: somehow opens false product info item
      this.dispatchEvent(new CustomEvent('ed-cfg:reset', {
        bubbles: true
      }));
      this.onBtnClose();
    }
  }, {
    key: "onBtnClose",
    value: function onBtnClose() {
      _get(_getPrototypeOf(IncompatibilityPopup.prototype), "onBtnClose", this).call(this);

      this.btnInitShare.style.display = 'block';
      this.shareContainer.classList.remove('visible');
    } ///

  }, {
    key: "generateShareUrl",
    value: function generateShareUrl() {
      var searchParams = new URLSearchParams(window.location.search);
      var fullUrl = location.protocol + '//' + location.host;
      var newRelativePathQuery = fullUrl + window.location.pathname + '?' + searchParams.toString();
      this.shareUrlInput.value = newRelativePathQuery;
      return this.currentShareUrl = newRelativePathQuery;
    }
  }, {
    key: "generateWhatsappUrl",
    value: function generateWhatsappUrl() {
      var urlEncodedText = encodeURIComponent(this.getAttribute('share-text'));
      var urlEncodedLink = encodeURIComponent(this.currentShareUrl);
      this.btnShareWhatsapp.href = 'https://wa.me/?text=' + urlEncodedText + ' ' + urlEncodedLink;
    }
    /** COPY HANDLING **/

  }, {
    key: "onCopyButton",
    value: function onCopyButton() {
      // Get the text field
      var copyText = this.shareUrlInput; // Select the text field

      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices
      // Copy the text inside the text field

      navigator.clipboard.writeText(copyText.value); // handle message

      this.copySuccessAlert.classList.add('visible');
      setTimeout(this.hideCopyAlert.bind(this), 2000);
    }
  }, {
    key: "hideCopyAlert",
    value: function hideCopyAlert() {
      this.copySuccessAlert.classList.remove('visible');
    }
    /** END COPY HANDLING **/

  }]);

  return IncompatibilityPopup;
}(ConfiguratorPopup);

customElements.define('ed-incompatibility-popup', IncompatibilityPopup);

var SavePopup = /*#__PURE__*/function (_ConfiguratorPopup3) {
  _inherits(SavePopup, _ConfiguratorPopup3);

  var _super4 = _createSuper(SavePopup);

  function SavePopup() {
    _classCallCheck(this, SavePopup);

    return _super4.apply(this, arguments);
  }

  _createClass(SavePopup, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(SavePopup.prototype), "connectedCallback", this).call(this);

      this._attachSelectors();

      this._attachListeners(); // FOR TESTING:
      //this.active = true;

    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.btnDownload = this.querySelector('.btn-download');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.btnDownload.addEventListener('click', this.onBtnDownload.bind(this));
    }
  }, {
    key: "onBtnDownload",
    value: function onBtnDownload() {
      var canvas = this.querySelector('canvas');
      /* OPTION 1: OPEN NEW TAB
      let dataURL = canvas.toDataURL("image/png");
      let newTab = window.open('about:blank','image from canvas');
      newTab.document.write("<img src='" + dataURL + "' alt='from canvas'/>");
       */

      /** OPTION 2: SAVE **/

      var link = document.createElement('a');
      link.download = 'download.png';
      link.href = canvas.toDataURL();
      link.click();
      link["delete"]();
    }
  }]);

  return SavePopup;
}(ConfiguratorPopup);

customElements.define('ed-save-popup', SavePopup);

var ItemRemovePopup = /*#__PURE__*/function (_ConfiguratorPopup4) {
  _inherits(ItemRemovePopup, _ConfiguratorPopup4);

  var _super5 = _createSuper(ItemRemovePopup);

  function ItemRemovePopup() {
    _classCallCheck(this, ItemRemovePopup);

    return _super5.apply(this, arguments);
  }

  _createClass(ItemRemovePopup, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(ItemRemovePopup.prototype), "connectedCallback", this).call(this);

      this._attachSelectors();

      this._attachListeners(); // FOR TESTING:
      //this.active = true;

    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.btnAbort = this.querySelector('.btn-abort');
      this.btnAccept = this.querySelector('.btn-accept');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.btnAccept.addEventListener('click', this.onBtnAccept.bind(this));
      this.btnAbort.addEventListener('click', this.onBtnClose.bind(this));
    }
  }, {
    key: "onBtnAccept",
    value: function onBtnAccept() {
      document.dispatchEvent(new CustomEvent('ed:cfg:remove-item:accept'));

      _get(_getPrototypeOf(ItemRemovePopup.prototype), "onBtnClose", this).call(this);
    }
  }]);

  return ItemRemovePopup;
}(ConfiguratorPopup);

customElements.define('ed-item-remove-popup', ItemRemovePopup);

/***/ }),

/***/ "./src/js/modules/ed-product-configurator/product-info.js":
/*!****************************************************************!*\
  !*** ./src/js/modules/ed-product-configurator/product-info.js ***!
  \****************************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ProductInfo = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ProductInfo, _HTMLElement);

  var _super = _createSuper(ProductInfo);

  function ProductInfo() {
    _classCallCheck(this, ProductInfo);

    return _super.apply(this, arguments);
  }

  _createClass(ProductInfo, [{
    key: "blockId",
    get:
    /** GETTERS AND SETTERS **/
    function get() {
      return this.getAttribute('block-id');
    },
    set: function set(value) {
      this.setAttribute('block-id', value);
    }
  }, {
    key: "baseCategory",
    get: function get() {
      return this.getAttribute('base-category');
    }
    /** END GETTERS AND SETTERS **/

  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.products = this.querySelectorAll('.product-info-item');
      this.emptyInfoItem = this.querySelector('.product-info-item.empty-item');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('ed:cfg:product:selected', this.onProductChange.bind(this));
      document.addEventListener('ed:cfg:variant:selected', this.onProductChange.bind(this));
      document.addEventListener('ed:cfg:category:change', this.onCategoryChange.bind(this));
      document.addEventListener('ed:cfg:variant:selected', this.updateCurrentInfoItem.bind(this));
      document.addEventListener('ed-cfg:reset', this.onAcceptReset.bind(this)); //document.addEventListener('ed-cfg:reset', this.updateCurrentInfoItem.bind(this));
    }
  }, {
    key: "onProductChange",
    value: function onProductChange(e) {
      var blockId = e.detail.blockId;
      var productId = e.detail.productId; // if we're not in the correct category, return

      if (this.blockId !== blockId) {
        this.classList.remove('open');
        return;
      } else {
        this.classList.add('open');
      } // remove active everywhere


      this.products.forEach(function (product) {
        product.classList.remove('active');
      }); // find item and set it to active

      var selectedProduct = this.querySelector('ed-product-info-item[data-block-id="' + blockId + '"][data-product-id="' + productId + '"]');

      if (selectedProduct) {
        selectedProduct.classList.add('active');
      } else {
        // if no selected product, re-enable the empty info
        this.emptyInfoItem.classList.add('active');
      }
    }
  }, {
    key: "onCategoryChange",
    value: function onCategoryChange(e) {
      if (this.blockId === e.detail.selectedCategory) {
        this.classList.add('open');
      } else {
        this.classList.remove('open');
      }
    } // needed cause the timing is pretty hard on reset or on share reload

  }, {
    key: "updateCurrentInfoItem",
    value: function updateCurrentInfoItem() {
      var element = document.querySelector('ed-category-item.selected');

      if ((element === null || element === void 0 ? void 0 : element.dataset.blockId) === this.blockId) {
        this.classList.add('open');
        return;
      }

      this.classList.remove('open');
      /**
       categories.forEach(category => {
          if (category.classList.contains('selected')) {
              let element = document.querySelector('ed-product-info[block-id="' + category.dataset.blockId + '"]');
              element.classList.add('open');
          } else {
              document.querySelector('ed-product-info[block-id="' + category.dataset.blockId + '"]').classList.remove('open');
          }
      })
       **/
    }
  }, {
    key: "onAcceptReset",
    value: function onAcceptReset() {
      setTimeout(function () {
        if (this.baseCategory === 'true') {
          this.classList.add('open');
        } else {
          this.classList.remove('open');
        }
      }.bind(this));
    }
  }]);

  return ProductInfo;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-product-info', ProductInfo);

var ProductInfoItem = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(ProductInfoItem, _HTMLElement2);

  var _super2 = _createSuper(ProductInfoItem);

  function ProductInfoItem() {
    _classCallCheck(this, ProductInfoItem);

    return _super2.apply(this, arguments);
  }

  _createClass(ProductInfoItem, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.btnClose = this.querySelector('.btn-remove');
      this.btnNext = this.querySelector('.btn-next');
      this.btnInfo = this.querySelector('.product-info-btn');
      this.quickBuyDrawer = this.querySelector('quick-buy-drawer');
      this.orderSummary = document.querySelector('ed-order-summary');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      if (this.btnClose) {
        this.btnClose.addEventListener('click', this.onBtnBack.bind(this));
      }

      if (this.btnNext) {
        this.btnNext.addEventListener('click', this.onBtnNext.bind(this));
      }

      this.btnInfo.addEventListener('click', this.onBtnInfo.bind(this));
    }
  }, {
    key: "onBtnBack",
    value: function onBtnBack() {
      var currentCategory = document.querySelector('.category-item.selected');
      currentCategory.previousElementSibling.click();
    }
  }, {
    key: "onBtnNext",
    value: function onBtnNext() {
      // get current category
      var currentCategory = document.querySelector('.category-item.selected');

      if (currentCategory.nextElementSibling) {
        document.dispatchEvent(new CustomEvent('ed-cfg:category:next', {
          bubbles: true
        }));
      } else {
        // finish configuration
        this.orderSummary.setAttribute('active', 'true');
      }
    }
  }, {
    key: "onBtnInfo",
    value: function onBtnInfo() {
      this.quickBuyDrawer.setAttribute('open', 'true');
    }
  }]);

  return ProductInfoItem;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-product-info-item', ProductInfoItem);

/***/ }),

/***/ "./src/js/modules/ed-product-configurator/product-preview.js":
/*!*******************************************************************!*\
  !*** ./src/js/modules/ed-product-configurator/product-preview.js ***!
  \*******************************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ProductPreview = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ProductPreview, _HTMLElement);

  var _super = _createSuper(ProductPreview);

  function ProductPreview() {
    _classCallCheck(this, ProductPreview);

    return _super.apply(this, arguments);
  }

  _createClass(ProductPreview, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.currentProducts = [];

      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.categories = document.querySelectorAll('ed-category-product-list');
      this.imageContainers = this.querySelectorAll('.preview-img-container');
      this.btnMobileNav = this.querySelector('.mobile-nav-container');
      this.defaultMobileNav = document.querySelector('.header__icon-wrapper[aria-controls="mobile-menu-drawer"]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      //document.addEventListener('ed:cfg:product:selected', this.onProductChange.bind(this));
      document.addEventListener('ed:cfg:variant:selected', this.onVariantChange.bind(this));
      this.btnMobileNav.addEventListener('click', this.onBtnMobileNav.bind(this));
    } // TODO: at the moment, if a new product is set, we render all images again, which is not optimized.
    // maybe we should just check if there is a check of loading old products

  }, {
    key: "onVariantChange",
    value: function onVariantChange(e) {
      var category = this.querySelector('.preview-img-container[data-block-id="' + e.detail.blockId + '"] .preview-img');

      if (e.detail.previewImg) {
        //category.src = this.createImage(e.detail.previewImg).src;
        this.addProduct(e);
      } else {
        category.src = '';
        this.removeProduct(e);
      }

      this.renderImages();
    }
    /*** NEW ***/

  }, {
    key: "renderImages",
    value: function renderImages() {
      var _this = this;

      /** check, if we need to force alt images **/
      var forceAltImg = false;
      this.currentProducts.forEach(function (product) {
        if (product.detail.forceAltImg === 'true') {
          forceAltImg = true;
        }
      });
      this.forceAltImg = forceAltImg;
      /** end **/

      this.currentProducts.forEach(function (product) {
        if (_this.forceAltImg) {
          _this.renderAltImage(product);
        } else {
          _this.renderDefaultImage(product);
        }

        _this.handleZIndex(product);

        if (product.detail.overrideAltImg) {
          _this.handleOverrideAltImg(product);
        }
      });
    }
  }, {
    key: "renderDefaultImage",
    value: function renderDefaultImage(product) {
      var imgContainer = Array.from(this.imageContainers).find(function (element) {
        return element.dataset.blockId === product.detail.blockId;
      });
      imgContainer.setAttribute('ed-loading', 'true');
      /** find product specific image **/

      var productSpecificImage = false;

      if (product.detail.productSpecificImages) {
        productSpecificImage = this.findProductSpecificImage(product);
      }
      /** end **/


      if (productSpecificImage) {
        imgContainer.firstElementChild.src = this.createImage(productSpecificImage[1], imgContainer).src;
      } else {
        // LOAD DEFAULT IMAGE
        imgContainer.firstElementChild.src = this.createImage(product.detail.previewImg, imgContainer).src; //default
      }
    }
  }, {
    key: "renderAltImage",
    value: function renderAltImage(product) {
      var imgContainer = Array.from(this.imageContainers).find(function (element) {
        return element.dataset.blockId === product.detail.blockId;
      });
      imgContainer.setAttribute('ed-loading', 'true');
      /** find product specific image **/

      var productSpecificImage = false;

      if (product.detail.productSpecificImages) {
        productSpecificImage = this.findProductSpecificImage(product);
      }
      /** end **/
      // first, load a product specific image. then alt preview image. then preview img.


      if (productSpecificImage) {
        imgContainer.firstElementChild.src = this.createImage(productSpecificImage[1], imgContainer).src;
      } else {
        // LOAD DEFAULT IMAGE
        if (product.detail.previewImgAlt) {
          imgContainer.firstElementChild.src = this.createImage(product.detail.previewImgAlt, imgContainer).src;
        } else {
          imgContainer.firstElementChild.src = this.createImage(product.detail.previewImg, imgContainer).src; //default
        }
      }
    }
  }, {
    key: "findProductSpecificImage",
    value: function findProductSpecificImage(product) {
      var _this2 = this;

      var array = Object.entries(product.detail.productSpecificImages);
      return array.find(function (element) {
        return _this2.currentProducts.find(function (x) {
          return x.detail.baseProductId === element[0];
        });
      });
    }
  }, {
    key: "handleZIndex",
    value: function handleZIndex(e) {
      var _this3 = this;

      var imageContainer = Array.from(this.imageContainers).find(function (imageContainer) {
        return imageContainer.dataset.blockId === e.detail.blockId;
      }); // wird gebraucht, da verschiedene Schulterriemen, abhängig vom Taschenkörper auch einen anderen z-index benötigen.

      if (e.detail.overrideZIndex) {
        var overrideZIndex = JSON.parse(e.detail.overrideZIndex);
        var specificProduct = overrideZIndex.find(function (element) {
          return _this3.currentProducts.find(function (product) {
            return product.detail.baseProductId === element.product_id;
          });
        });

        if (specificProduct) {
          imageContainer.style.zIndex = specificProduct.value;
        } else {
          imageContainer.style.zIndex = imageContainer.dataset.defaultZIndex;
        }
      } else {
        // default
        imageContainer.style.zIndex = imageContainer.dataset.defaultZIndex;
      }
    }
  }, {
    key: "handleOverrideAltImg",
    value: function handleOverrideAltImg(product) {
      /** override alt img **/
      var overrideAltImg = JSON.parse(product.detail.overrideAltImg);
      var value;
      var specificProduct = this.currentProducts.find(function (product) {
        var foundProduct = overrideAltImg.find(function (element) {
          return element.product_id === product.detail.baseProductId;
        });
        value = foundProduct === null || foundProduct === void 0 ? void 0 : foundProduct.value;
        return foundProduct;
      }); // TODO: disable flashing :-( maybe load sources before rendering?

      if (specificProduct) {
        if (value) {
          setTimeout(this.renderAltImage.bind(this, specificProduct), 10);
        } else {
          setTimeout(this.renderDefaultImage.bind(this, specificProduct), 10);
        }
      }
      /** end override alt img **/

    }
    /**** BASIC METHODS  *****/

  }, {
    key: "addProduct",
    value: function addProduct(e) {
      this.currentProducts = this.currentProducts.filter(function (x) {
        return x.detail.blockId !== e.detail.blockId;
      });
      this.currentProducts.push({
        detail: e.detail
      });
    }
  }, {
    key: "removeProduct",
    value: function removeProduct(e) {
      this.currentProducts = this.currentProducts.filter(function (x) {
        return x.detail.blockId !== e.detail.blockId;
      });
    }
  }, {
    key: "createImage",
    value: function createImage(src, imgContainer) {
      var img = new Image();
      img.onload = this.onImgLoad.bind(this, imgContainer);
      img.src = src;
      return img;
    }
  }, {
    key: "onImgLoad",
    value: function onImgLoad(imgContainer) {
      imgContainer.setAttribute('ed-loading', 'false');
    }
    /** END **/

  }, {
    key: "onBtnMobileNav",
    value: function onBtnMobileNav() {
      this.defaultMobileNav.click();
    }
  }]);

  return ProductPreview;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-product-preview', ProductPreview);

/***/ }),

/***/ "./src/js/modules/ed-product-configurator/product-selection.js":
/*!*********************************************************************!*\
  !*** ./src/js/modules/ed-product-configurator/product-selection.js ***!
  \*********************************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ProductSelection = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ProductSelection, _HTMLElement);

  var _super = _createSuper(ProductSelection);

  function ProductSelection() {
    _classCallCheck(this, ProductSelection);

    return _super.apply(this, arguments);
  }

  _createClass(ProductSelection, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.categories = this.querySelectorAll('.product-selection-wrapper');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      // LISTEN FOR CATEGORY SELECTION
      document.addEventListener('ed:cfg:category:change', this.onCategoryChange.bind(this));
    }
  }, {
    key: "onCategoryChange",
    value: function onCategoryChange(e) {
      var selectedCategory = e.detail.selectedCategory;
      this.categories.forEach(function (category) {
        if (category.dataset.blockId === selectedCategory) {
          category.classList.add('active');
        } else {
          category.classList.remove('active');
        }
      });
    }
  }]);

  return ProductSelection;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-product-selection', ProductSelection);

var CategoryProductList = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(CategoryProductList, _HTMLElement2);

  var _super2 = _createSuper(CategoryProductList);

  function CategoryProductList() {
    _classCallCheck(this, CategoryProductList);

    return _super2.apply(this, arguments);
  }

  _createClass(CategoryProductList, [{
    key: "active",
    get:
    /** GETTERS AND SETTERS **/
    function get() {
      return this.getAttribute('active');
    },
    set: function set(value) {
      this.setAttribute('active', value);
    }
  }, {
    key: "selectedProduct",
    get: function get() {
      return this.getAttribute('selected-product');
    },
    set: function set(value) {
      this.setAttribute('selected-product', value);
    }
  }, {
    key: "selectedVariant",
    get: function get() {
      return this.getAttribute('selected-variant');
    },
    set: function set(value) {
      this.setAttribute('selected-variant', value);
    }
  }, {
    key: "selectedPreviewImg",
    get: function get() {
      return this.getAttribute('selected-product-img');
    },
    set: function set(value) {
      this.setAttribute('selected-product-img', value);
    }
  }, {
    key: "preSelectProduct",
    get: function get() {
      return this.getAttribute('pre-select-product');
    }
  }, {
    key: "baseCategory",
    get: function get() {
      return this.getAttribute('base-category');
    }
    /** END GETTERS AND SETTERS **/

  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      if (this.baseCategory === 'true') {
        this.isBaseCategory = true;
      }

      if (this.getAttribute('required-category') === 'true') {
        this.requiredCategory = true;
      }

      this.baseCategoryBlockId = document.querySelector('ed-category-product-list[base-category="true"]').dataset.blockId; // setup compatibility check

      if (this.getAttribute('enable-compatibility-check')) {
        this.compatibilityCheckEnabled = true;
      }

      if (this.getAttribute('variant-selection') === 'disabled') {
        this.disabledVariantSelection = true;
      }

      this._attachSelectors();

      this._attachListeners();
      /** PRE SELECT **/


      if (this.isBaseCategory && !this.getProductUrlParams()) {
        document.addEventListener('DOMContentLoaded', this.applyBasePreSelect.bind(this));
      }
      /** END PRE SELECT **/

    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.productItems = this.querySelector('.product-items');
      this.products = this.querySelectorAll('.product-item');
      this.noFilterResultsContainer = this.querySelector('.no-filter-results-container');
      this.btnResetFilters = this.querySelector('.btn-filter-reset');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      this.products.forEach(function (item) {
        item.addEventListener('click', _this.onProductSelect.bind(_this, item));
      });
      this.btnResetFilters.addEventListener('click', this.resetFilters.bind(this));
      document.addEventListener('ed:cfg:apply-preselect', this.applyPreSelect.bind(this)); // FILTERS

      document.addEventListener('ed:cfg:filter:change', this.onFilterChange.bind(this));
      document.addEventListener('ed:cfg:filter-drawer:update', this.onFilterDrawerChange.bind(this));
      document.addEventListener('ed:cfg:preselect:product', this.onPreSelect.bind(this));
      document.addEventListener('ed-cfg:reset', this.onAcceptReset.bind(this)); // reset scroll
      //this.productItems.addEventListener('scroll', this.test.bind(this));
    }
  }, {
    key: "onProductSelect",
    value: function onProductSelect(product) {
      // CHECK FOR COMPATIBILITY: WARNING - DOES NOT INVOLVE VARIANT SELECT
      // only enable check in base category
      if (this.isBaseCategory) {
        if (!this.isProductCompatible(product)) {
          this.cacheSelectedProduct = product;
          document.querySelector('ed-incompatibility-popup').setAttribute('active', 'true');
          return;
        }
      }

      this.selectProduct(product);
    }
  }, {
    key: "selectProduct",
    value: function selectProduct(product) {
      if (!product) {
        return;
      } // ON REMOVE


      if (product.classList.contains('selected')) {
        if (!this.requiredCategory) {
          this.removeProduct(product);
        }

        return;
      }

      this.products.forEach(function (item) {
        if (item !== product) {
          item.classList.remove('selected');
        }
      });
      product.classList.add('selected');
      this.applyProductCompatibility();
      this.selectedProduct = this.selectedProduct;
      this.selectedVariant = product.dataset.variantId;
      this.selectedPreviewImg = product.dataset.previewImg; // handle product specific images

      var productSpecificImages;
      var specificImages = product.querySelector('script[type="application/json"]');

      if (specificImages) {
        productSpecificImages = JSON.parse(specificImages.innerHTML);
      } // check if product has variant selection or filter bar is enabled


      if (!this.disabledVariantSelection) {
        this.dispatchEvent(new CustomEvent('ed:cfg:product:selected', {
          bubbles: true,
          detail: {
            blockId: this.getAttribute('block-id'),
            productId: product.dataset.productId,
            variantId: product.dataset.variantId,
            previewImg: product.dataset.previewImg,
            productSpecificImages: productSpecificImages
          }
        }));
      } else {
        this.dispatchEvent(new CustomEvent('ed:cfg:variant:selected', {
          bubbles: true,
          detail: {
            blockId: this.getAttribute('block-id'),
            productId: product.dataset.productId,
            variantId: product.dataset.variantId,
            title: product.dataset.title,
            price: product.dataset.price,
            comparePrice: product.dataset.comparePrice,
            thumbnailImg: product.dataset.thumbnailImg,
            previewImg: product.dataset.previewImg,
            previewImgAlt: product.dataset.previewImgAlt,
            forceAltImg: product.dataset.forceAltImg,
            compatibleProducts: product.dataset.compatibleProducts,
            productSpecificImages: productSpecificImages,
            variantSelect: true,
            overrideZIndex: product.dataset.overrideZIndex,
            overrideAltImg: product.dataset.overrideAltImg,
            hasVariants: product.dataset.hasVariants
          }
        }));
      }
    }
  }, {
    key: "removeProduct",
    value: function removeProduct(product) {
      if (product) {
        product.classList.remove('selected');
        this.selectedProduct = '';
        this.selectedVariant = '';
        this.selectedPreviewImg = '';
        this.dispatchEvent(new CustomEvent('ed:cfg:variant:selected', {
          bubbles: true,
          detail: {
            blockId: product.dataset.blockId
          }
        })); // TODO: NOT SURE IF THIS IS STILL NEEDED

        this.dispatchEvent(new CustomEvent('ed:cfg:product:selected', {
          bubbles: true,
          detail: {
            blockId: product.dataset.blockId
          }
        }));
      }
    }
    /*** COMPATIBILITY HANDLING ***/

  }, {
    key: "isProductCompatible",
    value: function isProductCompatible(product) {
      var _this2 = this;

      // cache arrays, as we dont know if the user accepts the warning
      this.productRemoveCache = [];
      this.productHideCache = [];
      this.productShowCache = [];
      var foundIncompatibility = false;
      var compatibleProducts = product.dataset.compatibleProducts.split('|');
      var productLists = document.querySelectorAll('ed-category-product-list');
      productLists.forEach(function (productList) {
        // base categories always enabled
        if (productList.getAttribute('enable-compatibility-check') === 'true' && productList.getAttribute('base-category') !== 'true' && productList.dataset.blockId !== _this2.dataset.blockId) {
          var productItems = productList.querySelectorAll('.product-item');
          productItems.forEach(function (productItem) {
            if (!compatibleProducts.includes(productItem.dataset.productId)) {
              if (productItem.classList.contains('selected')) {
                // found a product which is selected: save it in a cache, to wait for the user to accept it
                _this2.productRemoveCache.push(productItem);

                foundIncompatibility = true;
              }

              _this2.productHideCache.push(productItem);
            } else {
              _this2.productShowCache.push(productItem);
            }
          });
        }
      }); // now, return true or false

      return !foundIncompatibility;
    }
  }, {
    key: "onAcceptReset",
    value: function onAcceptReset() {
      // resets all products except the base category product
      if (!this.isBaseCategory) {
        var product = this.querySelector('.product-item.selected');
        this.removeProduct(product);
      } //this.onRemoveIncompatibleProducts(); ALT: Hat nur die inkompatiblen Produkte entfernt


      this.selectProduct(this.cacheSelectedProduct);
      this.applyProductCompatibility();
    } // resets only the incompatible product

  }, {
    key: "onRemoveIncompatibleProducts",
    value: function onRemoveIncompatibleProducts() {
      var _this$productRemoveCa,
          _this3 = this;

      if (((_this$productRemoveCa = this.productRemoveCache) === null || _this$productRemoveCa === void 0 ? void 0 : _this$productRemoveCa.length) > 0) {
        this.productRemoveCache.forEach(function (product) {
          _this3.removeIncompatibleProduct(product);
        });
        this.productRemoveCache = [];
      }
    }
  }, {
    key: "applyProductCompatibility",
    value: function applyProductCompatibility() {
      var _this$productShowCach, _this$productHideCach;

      if (((_this$productShowCach = this.productShowCache) === null || _this$productShowCach === void 0 ? void 0 : _this$productShowCach.length) > 0) {
        this.productShowCache.forEach(function (product) {
          //product.style.display = 'flex';
          product.classList.remove('incompatible');
        });
      }

      if (((_this$productHideCach = this.productHideCache) === null || _this$productHideCach === void 0 ? void 0 : _this$productHideCach.length) > 0) {
        this.productHideCache.forEach(function (product) {
          ///product.style.display = 'none';
          product.classList.add('incompatible');
        });
      }
    }
  }, {
    key: "removeIncompatibleProduct",
    value: function removeIncompatibleProduct(product) {
      product.classList.remove('selected');
      this.selectedProduct = '';
      this.selectedVariant = '';
      this.selectedPreviewImg = '';
      this.dispatchEvent(new CustomEvent('ed:cfg:variant:selected', {
        bubbles: true,
        detail: {
          blockId: product.dataset.blockId,
          reset: true
        }
      }));
    }
    /*** END COMPATIBILITY HANDLING ***/

  }, {
    key: "resetALlProducts",
    value: function resetALlProducts() {
      this.products.forEach(function (product) {
        product.style.display = 'flex';
      });
      this.currentProducts = this.products;
    }
    /*** FILTER HANDLING ***/

  }, {
    key: "onFilterChange",
    value: function onFilterChange(e) {
      var targetCategory = e.detail.blockId;
      var filterType = e.detail.filterType;
      var filterValues = e.detail.filters;

      if (this.dataset.blockId !== targetCategory) {
        return;
      }

      this.activeFilters = e.detail.filters;
      this.applyAllFilters();
    }
  }, {
    key: "resetFilters",
    value: function resetFilters() {
      this.products.forEach(function (product) {
        product.classList.remove('hidden');
      });
      this.productItems.classList.remove('no-results');
      this.noFilterResultsContainer.classList.remove('active');
      this.currentProducts = this.products;
      document.dispatchEvent(new CustomEvent('ed:cfg:reset-filters'));
    }
    /** FILTER DRAWER HANDLING **/

  }, {
    key: "onFilterDrawerChange",
    value: function onFilterDrawerChange(e) {
      if (e.detail.blockId === this.dataset.blockId) {
        var activeFilters = e.detail.filters;
        this.activeDrawerFilters = activeFilters;
        this.applyAllFilters(); //this.applyDrawerFiltersNew(activeFilters);
      }
    }
  }, {
    key: "applyAllFilters",
    value: function applyAllFilters() {
      var _this4 = this;

      this.filteredProducts = [];
      this.products.forEach(function (product) {
        var showProduct = true;
        product.classList.remove('hidden'); // main filters first

        if (_this4.activeFilters) {
          _this4.activeFilters.forEach(function (filter) {
            var productFilter = product.getAttribute('data-filter-' + filter.key);
            var productFilterValues = productFilter.split('|');

            if (productFilter && !productFilterValues.includes(filter.value)) {
              showProduct = false;
            }
          });
        }

        if (!showProduct) {
          product.classList.add('hidden');
        } else {
          _this4.filteredProducts.push(product);
        }
      });

      if (this.activeDrawerFilters) {
        var emptyFilterCategories = 0;
        var resetFilters = false;
        this.activeDrawerFilters.forEach(function (filter) {
          Object.values(filter).forEach(function (activeValues) {
            if (activeValues.length === 0) {
              emptyFilterCategories += 1;
            }
          });
        });

        if (emptyFilterCategories >= this.activeDrawerFilters.length) {
          resetFilters = true;
        } // now filter drawer


        this.filteredProducts.forEach(function (product) {
          var showProduct;
          /** Logik:
           * - Innerhalb einer Filterkategorie gilt die ODER-Logik
           * - Bei mehreren Kategorien gilt die UND-Logik
           * - Sobald in einer aktiven Filterkategorie ein Wert nicht vorhanden ist, wird nicht mehr gesucht
           **/

          if (!resetFilters) {
            var areAllCategoriesTrue = true;

            _this4.activeDrawerFilters.forEach(function (filter) {
              var filterTitle = Object.keys(filter)[0];
              var productFilter = product.getAttribute('data-filter-' + filterTitle);
              var productFilterValues = productFilter.split('|');
              var breakLoop = false;
              Object.values(filter).forEach(function (activeValues) {
                if (activeValues.length === 0 || breakLoop) {
                  return;
                }

                var some = activeValues.some(function (r) {
                  return productFilterValues.includes(r);
                });

                if (!some) {
                  areAllCategoriesTrue = false;
                  breakLoop = true;
                }
              });
            });

            showProduct = areAllCategoriesTrue;
          } else {
            // catches if filters are resetted
            showProduct = true;
          }

          if (showProduct) {
            product.classList.remove('hidden');
          } else {
            product.classList.add('hidden');
          }
        });
      }
      /** show message if no products are found **/


      if (this.countActiveProducts() === 0) {
        this.productItems.classList.add('no-results');
        this.noFilterResultsContainer.classList.add('active');
      } else {
        this.productItems.classList.remove('no-results');
        this.noFilterResultsContainer.classList.remove('active');
      }

      this.resetScroll();
    }
  }, {
    key: "applyAllFiltersOld",
    value: function applyAllFiltersOld() {
      var _this5 = this;

      this.filteredProducts = [];
      this.products.forEach(function (product) {
        var showProduct = true;
        product.classList.remove('hidden'); // main filters first

        if (_this5.activeFilters) {
          _this5.activeFilters.forEach(function (filter) {
            var productFilter = product.getAttribute('data-filter-' + filter.key);
            var productFilterValues = productFilter.split('|');

            if (productFilter && !productFilterValues.includes(filter.value)) {
              showProduct = false;
            }
          });
        }

        if (!showProduct) {
          product.classList.add('hidden');
        } else {
          _this5.filteredProducts.push(product);
        }
      });

      if (this.activeDrawerFilters) {
        // first, count empty filter categories
        var emptyFilterCategories = 0;
        var resetFilters = false;
        this.activeDrawerFilters.forEach(function (filter) {
          Object.values(filter).forEach(function (activeValues) {
            if (activeValues.length === 0) {
              emptyFilterCategories += 1;
            }
          });
        });

        if (emptyFilterCategories >= this.activeDrawerFilters.length) {
          resetFilters = true;
        }

        this.filteredProducts.forEach(function (product) {
          var showProduct = false; // now filter drawer

          if (!resetFilters) {
            _this5.activeDrawerFilters.forEach(function (filter) {
              var filterTitle = Object.keys(filter)[0];
              var productFilter = product.getAttribute('data-filter-' + filterTitle);
              var productFilterValues = productFilter.split('|');
              Object.values(filter).forEach(function (activeValues) {
                activeValues.forEach(function (value) {
                  if (productFilterValues.includes(value)) {
                    showProduct = true;
                  }
                });
              });
            });
          } else {
            // catches if filters are resetted
            showProduct = true;
          }

          if (showProduct) {
            product.classList.remove('hidden');
          } else {
            product.classList.add('hidden');
          }
        });
      }
      /** show message if no products are found **/


      if (this.countActiveProducts() === 0) {
        this.productItems.classList.add('no-results');
        this.noFilterResultsContainer.classList.add('active');
      } else {
        this.productItems.classList.remove('no-results');
        this.noFilterResultsContainer.classList.remove('active');
      }

      this.resetScroll();
    }
  }, {
    key: "countActiveProducts",
    value: function countActiveProducts() {
      var activeProducts = 0;
      this.products.forEach(function (product) {
        if (!product.classList.contains('hidden') && !product.classList.contains('incompatible')) {
          activeProducts++;
        }
      });
      return activeProducts;
    }
    /*** PRE SELECTION ***/

  }, {
    key: "applyBasePreSelect",
    value: function applyBasePreSelect() {
      var _this6 = this;

      var preSelectProduct = false;

      if (this.preSelectProduct) {
        // if handle is configurated
        preSelectProduct = Array.from(this.products).find(function (product) {
          return product.dataset.productId === _this6.preSelectProduct;
        });
      }

      if (!preSelectProduct) {
        preSelectProduct = this.products[0];
      }

      this.onProductSelect(preSelectProduct);
    }
  }, {
    key: "applyPreSelect",
    value: function applyPreSelect(e) {
      var _this7 = this;

      // pre selects, if a new category gets acivated
      if (e.detail.blockId === this.dataset.blockId) {
        if (this.preSelectProduct || this.preSelectProduct === '') {
          var preSelectProduct = Array.from(this.products).find(function (product) {
            return product.dataset.productId === _this7.preSelectProduct;
          });

          if (!preSelectProduct) {
            preSelectProduct = this.products[0];
          }

          this.selectProduct(preSelectProduct);
        }
      }
    }
    /** URL PRE SELECT **/

  }, {
    key: "onPreSelect",
    value: function onPreSelect(e) {
      if (e.detail.blockId === this.dataset.blockId) {
        if (e.detail.variantId && !e.detail.productId) {
          // if it is only a pre selected product without variant select
          var preSelectProduct = Array.from(this.products).find(function (product) {
            return product.dataset.variantId === e.detail.variantId;
          });
          this.onProductSelect(preSelectProduct);
        } else if (e.detail.variantId && e.detail.productId) {
          var _preSelectProduct = Array.from(this.products).find(function (product) {
            return product.dataset.productId === e.detail.productId;
          });

          this.onProductSelect(_preSelectProduct); // to: VariantSelection

          this.dispatchEvent(new CustomEvent('ed:cfg:preselect:variant', {
            bubbles: true,
            detail: {
              blockId: e.detail.blockId,
              variantId: e.detail.variantId
            }
          }));
        }
      }
    }
  }, {
    key: "getProductUrlParams",
    value: function getProductUrlParams() {
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      return urlParams.get('products');
    } // reset scroll

  }, {
    key: "resetScroll",
    value: function resetScroll() {
      this.productItems.scrollLeft = 0; //TODO: does not work somehow

      this.productItems.scrollTop = 0; //TODO: does not work somehow
    }
  }]);

  return CategoryProductList;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-category-product-list', CategoryProductList);

/***/ }),

/***/ "./src/js/modules/ed-product-configurator/variant-selection.js":
/*!*********************************************************************!*\
  !*** ./src/js/modules/ed-product-configurator/variant-selection.js ***!
  \*********************************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var VariantSelection = /*#__PURE__*/function (_HTMLElement) {
  _inherits(VariantSelection, _HTMLElement);

  var _super = _createSuper(VariantSelection);

  function VariantSelection() {
    _classCallCheck(this, VariantSelection);

    return _super.apply(this, arguments);
  }

  _createClass(VariantSelection, [{
    key: "selectedProduct",
    get:
    /** GETTERS AND SETTERS **/
    function get() {
      return this.getAttribute('selected-product');
    },
    set: function set(value) {
      this.setAttribute('selected-product', value);
    }
  }, {
    key: "selectedVariant",
    get: function get() {
      return this.getAttribute('selected-variant');
    },
    set: function set(value) {
      this.setAttribute('selected-variant', value);
    }
  }, {
    key: "selectedPreviewImg",
    get: function get() {
      return this.getAttribute('selected-product-img');
    },
    set: function set(value) {
      this.setAttribute('selected-product-img', value);
    }
  }, {
    key: "blockId",
    get: function get() {
      return this.getAttribute('block-id');
    },
    set: function set(value) {
      this.setAttribute('block-id', value);
    }
  }, {
    key: "baseCategory",
    get: function get() {
      return this.getAttribute('base-category');
    }
    /** END GETTERS AND SETTERS **/

  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.productsWrapper = this.querySelectorAll('.product-variants-wrapper');
      this.productVariants = this.querySelectorAll('.product-variant-item');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      document.addEventListener('ed:cfg:product:selected', this.onProductChange.bind(this));
      document.addEventListener('ed:cfg:category:selected', this.onCategoryChange.bind(this));
      document.addEventListener('ed:cfg:preselect:variant', this.onPreSelect.bind(this));
      document.addEventListener('ed-cfg:reset', this.onAcceptReset.bind(this));
      this.productVariants.forEach(function (item) {
        item.addEventListener('click', _this.onVariantSelect.bind(_this, item));
      });
    }
  }, {
    key: "onVariantSelect",
    value: function onVariantSelect(variant) {
      var _this2 = this;

      if (variant) {
        var currentProductsWrapper = variant.parentElement; // TODO: ON REMOVE + ON SAME

        currentProductsWrapper.querySelectorAll('.product-variant-item').forEach(function (item) {
          if (item.dataset.variantId === variant.dataset.variantId) {
            item.classList.add('selected');
            _this2.selectedProduct = variant.dataset.productId;
            _this2.selectedVariant = variant.dataset.variantId;
            _this2.selectedPreviewImg = variant.dataset.previewImg;

            _this2.dispatchEvent(new CustomEvent('ed:cfg:variant:selected', {
              bubbles: true,
              detail: {
                blockId: _this2.blockId,
                baseProductId: variant.dataset.baseProductId,
                productId: variant.dataset.productId,
                variantId: variant.dataset.variantId,
                title: variant.dataset.title,
                price: variant.dataset.price,
                comparePrice: variant.dataset.comparePrice,
                previewImg: variant.dataset.previewImg,
                previewImgAlt: variant.dataset.previewImgAlt,
                forceAltImg: variant.dataset.forceAltImg,
                compatibleProducts: variant.dataset.compatibleProducts
              }
            }));
          } else {
            item.classList.remove('selected');
          }
        });
      } else {
        this.selectedProduct = '';
        this.selectedVariant = '';
        this.selectedPreviewImg = '';
        this.dispatchEvent(new CustomEvent('ed:cfg:variant:selected', {
          bubbles: true,
          detail: {
            blockId: this.blockId
          }
        }));
      }
    }
  }, {
    key: "onProductChange",
    value: function onProductChange(e) {
      var _this3 = this;

      var selectedBlockId = e.detail.blockId;
      var selectedProductId = e.detail.productId;

      if (this.blockId === selectedBlockId) {
        this.classList.add('visible');

        if (selectedProductId) {
          this.productsWrapper.forEach(function (wrapper) {
            if (wrapper.dataset.productId === selectedProductId) {
              wrapper.classList.add('active');
              wrapper.querySelectorAll('.product-variant-item').forEach(function (item) {
                item.classList.remove('selected');
              });
              wrapper.children[0].classList.add('selected');
              _this3.selectedProduct = wrapper.dataset.productId;
              _this3.selectedVariant = wrapper.dataset.variantId;
              _this3.selectedPreviewImg = wrapper.dataset.previewImg; // trigger the variant select

              _this3.onVariantSelect(wrapper.children[0]);
            } else {
              wrapper.classList.remove('active');
            }
          });
        } else {
          // if product is removed, empty string
          this.selectedProduct = '';
          this.selectedVariant = '';
          this.selectedPreviewImg = '';
          this.classList.remove('visible');
          this.productsWrapper.forEach(function (wrapper) {
            var selectedItem = wrapper.querySelector('.product-variant-item.selected');

            if (selectedItem) {
              selectedItem.classList.remove('selected');
            }
          }); // trigger variant select

          this.onVariantSelect(null);
        }
      } else {
        if (!e.detail.reset) {
          // prevents disappearing variant select on reset. maybe not logical implementation
          this.classList.remove('visible');
        }
      }
    }
  }, {
    key: "onCategoryChange",
    value: function onCategoryChange(e) {
      this.classList.remove('visible');
      var productSelect = document.querySelector('ed-category-product-list[data-block-id="' + e.detail.blockId + '"]'); // make visible with same product id

      if (productSelect) {
        var selectedProduct = productSelect.querySelector('.product-item.selected');

        if (selectedProduct) {
          var selectedProductId = selectedProduct.dataset.productId;
          var currentProductsWrapper = this.querySelector('.product-variants-wrapper[data-product-id="' + selectedProductId + '"]');

          if (currentProductsWrapper) {
            // catch if product has no variants
            currentProductsWrapper.classList.add('active');
            this.classList.add('visible');
          }
        }
      }
    }
  }, {
    key: "onAcceptReset",
    value: function onAcceptReset() {
      if (this.baseCategory === 'true') {
        setTimeout(function () {
          this.classList.add('visible');
        }.bind(this));
      }
    }
    /** URL PRE SELECT **/

  }, {
    key: "onPreSelect",
    value: function onPreSelect(e) {
      if (this.blockId === e.detail.blockId) {
        var preSelectVariant = Array.from(this.productVariants).find(function (x) {
          return x.dataset.variantId === e.detail.variantId;
        });
        this.onVariantSelect(preSelectVariant);
      }
    }
  }]);

  return VariantSelection;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-variant-selection', VariantSelection);

/***/ }),

/***/ "./src/js/modules/ed-product-configurator/variant-selector.js":
/*!********************************************************************!*\
  !*** ./src/js/modules/ed-product-configurator/variant-selector.js ***!
  \********************************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var VariantSelector = /*#__PURE__*/function (_HTMLElement) {
  _inherits(VariantSelector, _HTMLElement);

  var _super = _createSuper(VariantSelector);

  function VariantSelector() {
    _classCallCheck(this, VariantSelector);

    return _super.apply(this, arguments);
  }

  _createClass(VariantSelector, [{
    key: "selectedVariantId",
    set:
    /** GETTERS AND SETTERS **/
    function set(value) {
      return this.setAttribute('selected-variant-id', value);
    }
  }, {
    key: "selectedComparePrice",
    set: function set(value) {
      return this.setAttribute('selected-compare-price', value);
    }
  }, {
    key: "selectedPrice",
    set: function set(value) {
      return this.setAttribute('selected-price', value);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.select = this.querySelector('select');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.select.addEventListener('change', this.onSelect.bind(this));
    }
  }, {
    key: "onSelect",
    value: function onSelect(e) {
      var selectedOption = this.select.options[this.select.selectedIndex];
      this.selectedPrice = selectedOption.dataset.price;
      this.selectedComparePrice = selectedOption.dataset.comparePrice;
      this.selectedVariantId = selectedOption.dataset.variantId; //document.dispatchEvent(new CustomEvent('ed:cfg:variant-select'));
    }
  }]);

  return VariantSelector;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-cfg-variant-item-selector', VariantSelector);

/***/ }),

/***/ "./src/js/modules/methods.js":
/*!***********************************!*\
  !*** ./src/js/modules/methods.js ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "formatMoney": () => (/* binding */ formatMoney)
/* harmony export */ });
var formatMoney = function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || '${{amount}}';

  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
        dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }

  var value = '';

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;

    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;

    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;

    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;

    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;

    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
  }

  if (formatString.indexOf('with_comma_separator') !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
};

/***/ }),

/***/ "./src/js/modules/product-configurator-components.js":
/*!***********************************************************!*\
  !*** ./src/js/modules/product-configurator-components.js ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ed_product_configurator_product_preview__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ed-product-configurator/product-preview */ "./src/js/modules/ed-product-configurator/product-preview.js");
/* harmony import */ var _ed_product_configurator_product_preview__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ed_product_configurator_product_preview__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ed_product_configurator_variant_selection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ed-product-configurator/variant-selection */ "./src/js/modules/ed-product-configurator/variant-selection.js");
/* harmony import */ var _ed_product_configurator_variant_selection__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ed_product_configurator_variant_selection__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ed_product_configurator_product_info__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ed-product-configurator/product-info */ "./src/js/modules/ed-product-configurator/product-info.js");
/* harmony import */ var _ed_product_configurator_product_info__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ed_product_configurator_product_info__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ed_product_configurator_category_selection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./ed-product-configurator/category-selection */ "./src/js/modules/ed-product-configurator/category-selection.js");
/* harmony import */ var _ed_product_configurator_category_selection__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ed_product_configurator_category_selection__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ed_product_configurator_filter_bar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./ed-product-configurator/filter-bar */ "./src/js/modules/ed-product-configurator/filter-bar.js");
/* harmony import */ var _ed_product_configurator_filter_bar__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ed_product_configurator_filter_bar__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _ed_product_configurator_order_summary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ed-product-configurator/order-summary */ "./src/js/modules/ed-product-configurator/order-summary.js");
/* harmony import */ var _ed_product_configurator_popups__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ed-product-configurator/popups */ "./src/js/modules/ed-product-configurator/popups.js");
/* harmony import */ var _ed_product_configurator_popups__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_ed_product_configurator_popups__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _ed_product_configurator_filters__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./ed-product-configurator/filters */ "./src/js/modules/ed-product-configurator/filters.js");
/* harmony import */ var _ed_product_configurator_filters__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_ed_product_configurator_filters__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _ed_product_configurator_product_selection__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./ed-product-configurator/product-selection */ "./src/js/modules/ed-product-configurator/product-selection.js");
/* harmony import */ var _ed_product_configurator_product_selection__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_ed_product_configurator_product_selection__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _ed_product_configurator_variant_selector__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./ed-product-configurator/variant-selector */ "./src/js/modules/ed-product-configurator/variant-selector.js");
/* harmony import */ var _ed_product_configurator_variant_selector__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_ed_product_configurator_variant_selector__WEBPACK_IMPORTED_MODULE_9__);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }












var ProductConfiguratorMain = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ProductConfiguratorMain, _HTMLElement);

  var _super = _createSuper(ProductConfiguratorMain);

  function ProductConfiguratorMain() {
    _classCallCheck(this, ProductConfiguratorMain);

    return _super.apply(this, arguments);
  }

  _createClass(ProductConfiguratorMain, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.currentProducts = [];
      this.categories = this.querySelectorAll('ed-category-item');
      this.preSelectParams = this.getProductUrlParams();

      this._attachSelectors();

      this._attachListeners();

      this.removeAttribute('ed-loading');
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.titles = this.querySelectorAll('.category-header-inner .title .title-value');
      this.orderSummary = document.querySelector('ed-order-summary');
      this.btnFilter = this.querySelector('.btn-filter');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('ed:cfg:category:change', this.onCategoryChange.bind(this));
      document.addEventListener('ed:cfg:variant:selected', this.onVariantChange.bind(this));

      if (this.preSelectParams) {
        document.addEventListener('DOMContentLoaded', this.onProductPreSelectParams.bind(this));
      }
    }
  }, {
    key: "onCategoryChange",
    value: function onCategoryChange(e) {
      this.updateTitleContainer(e.detail.selectedCategory);
    }
    /** URL HANDLING **/

  }, {
    key: "onVariantChange",
    value: function onVariantChange(e) {
      if (e.detail.previewImg) {
        this.addProduct(e);
      } else {
        this.removeProduct(e);
      }

      this.updateProductParams(); //this.updateSecondaryParams();
    }
  }, {
    key: "updateProductParams",
    value: function updateProductParams() {
      var _this = this;

      var params = '';
      var count = this.currentProducts.length;
      var found = 0;
      this.categories.forEach(function (category) {
        var categoryId = category.dataset.blockId;

        var product = _this.currentProducts.find(function (x) {
          return x.detail.blockId === categoryId;
        });

        if (product) {
          if (product.detail) {
            if (category.getAttribute('variant-select') === 'true') {
              params += product.detail.baseProductId + '+';
            }

            params += product.detail.variantId;
            found++;
          }
        }

        if (count !== found) {
          params += '|';
        }
      });

      if ('URLSearchParams' in window) {
        var searchParams = new URLSearchParams(window.location.search);
        searchParams.set("products", params);
        var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
        history.pushState(null, '', newRelativePathQuery);
      }
    }
    /*
    updateSecondaryParams() {
        if ('URLSearchParams' in window) {
            let searchParams = new URLSearchParams(window.location.search)
            searchParams.set("pimmel", "schwanz");
            let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
            history.pushState(null, '', newRelativePathQuery);
        }
    }
     */

  }, {
    key: "getProductUrlParams",
    value: function getProductUrlParams() {
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      return urlParams.get('products');
    }
  }, {
    key: "isShareUrl",
    value: function isShareUrl() {
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      return urlParams.get('share');
    }
    /** END URL HANDLING **/

    /** PRE SELECT HANDLING **/

  }, {
    key: "onProductPreSelectParams",
    value: function onProductPreSelectParams() {
      var _this2 = this;

      var paramsArray = this.preSelectParams.split('|');
      paramsArray.forEach(function (param, index) {
        var categoryId = _this2.categories[index].dataset.blockId;

        if (param) {
          if (param.includes('+')) {
            var productId = param.split('+')[0];
            var variantId = param.split('+')[1]; // to: CategoryProductList

            _this2.dispatchEvent(new CustomEvent('ed:cfg:preselect:product', {
              bubbles: true,
              detail: {
                blockId: categoryId,
                productId: productId,
                variantId: variantId
              }
            }));
          } else {
            // 127.0.0.1:9292/pages/ed-konfigurator?products=7067572404389%2B40890481574053|39386852524197|41146235650213
            // to: CategoryProductList
            _this2.dispatchEvent(new CustomEvent('ed:cfg:preselect:product', {
              bubbles: true,
              detail: {
                blockId: categoryId,
                variantId: param
              }
            }));
          }
        }
      });
      this.unlockCategories(); // after the selected the products, make sure to enable the categories

      this.checkOrderSummary();
    }
  }, {
    key: "unlockCategories",
    value: function unlockCategories() {
      var _this3 = this;

      this.currentProducts.forEach(function (product) {
        Array.from(_this3.categories).find(function (category) {
          return category.dataset.blockId === product.detail.blockId;
        }).classList.add('enabled');
      });
    }
  }, {
    key: "checkOrderSummary",
    value: function checkOrderSummary() {
      var _this4 = this;

      var orderSummaryEnabled = true;

      var _loop = function _loop(i) {
        if (_this4.categories[i].getAttribute('required-category') === 'true') {
          // check if category has a product
          var product = _this4.currentProducts.find(function (product) {
            return product.detail.blockId === _this4.categories[i].dataset.blockId;
          });

          if (!product) {
            orderSummaryEnabled = false;
          }
        }
      };

      for (var i = 0; i < this.categories.length; i++) {
        _loop(i);
      }

      if (orderSummaryEnabled && this.isShareUrl()) {
        this.orderSummary.setAttribute('active', 'true');
      }
    }
    /** **/

  }, {
    key: "updateTitleContainer",
    value: function updateTitleContainer(id) {
      this.titles.forEach(function (title) {
        if (title.id === id) {
          title.classList.add('visible');
        } else {
          title.classList.remove('visible');
        }
      });
    }
    /** GENERAL METHODS **/

  }, {
    key: "addProduct",
    value: function addProduct(e) {
      this.currentProducts = this.currentProducts.filter(function (x) {
        return x.detail.blockId !== e.detail.blockId;
      });
      this.currentProducts.push({
        detail: e.detail
      });
    }
  }, {
    key: "removeProduct",
    value: function removeProduct(e) {
      this.currentProducts = this.currentProducts.filter(function (x) {
        return x.detail.blockId !== e.detail.blockId;
      });
    }
  }]);

  return ProductConfiguratorMain;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-product-configurator-main', ProductConfiguratorMain);

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!**************************!*\
  !*** ./src/js/custom.js ***!
  \**************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_ed_free_gifts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/ed-free-gifts */ "./src/js/modules/ed-free-gifts.js");
/* harmony import */ var _modules_ed_free_gifts__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_free_gifts__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _modules_product_configurator_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/product-configurator-components */ "./src/js/modules/product-configurator-components.js");
/*
DO NOT TOUCH THIS FILE OUTSIDE OF /src DIRECTORY
this file gets compiled ./assets/custom.js - make sure to import every module here.
*/

/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


/*import '../../node_modules/html2canvas';*/
})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!******************************!*\
  !*** ./src/scss/custom.scss ***!
  \******************************/
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin

})();

/******/ })()
;